import React, { useEffect, useRef, useState } from 'react'
import _ from 'lodash'
import { Bracket, Seed, SeedItem, SeedTeam } from 'react-brackets'

import './css/tournament-table-scoring.css'
import { Col, Modal, Radio, Row, Space } from 'antd'
import Button from 'antd-button-color'
import { EditOutlined, PrinterOutlined, StarFilled } from '@ant-design/icons'
import TableScoreCard from './TableScoreCard'
import PrintTable from './PrintTable'
import { useReactToPrint } from 'react-to-print'

import { generateMatches, calcNumberRounds } from '../../../../shared/eliminations'

const TournamentTableScoring = (props) => {
  const [rounds, setRounds] = useState([])
  const [seeding, setSeeding] = useState([])
  const [isSetScoreVisible, setIsSetScoreVisible] = useState(false)
  const [currentMatch, setCurrentMatch] = useState({})
  const [isPrintVisible, setIsPrintVisible] = useState(false)
  const [printValue, setPrintValue] = useState('a')

  const printTableRef = useRef()

  const handlePrintTable = useReactToPrint({
    content: () => printTableRef.current
  })

  const [tournament, setTournament] = useState({})
  const [config, setConfig] = useState({})
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    const newTournament = props.tournament
    // clear next step
    const nextStep = props.step + 1
    let stepName = props.tournament.schedule[nextStep]
    if (stepName === 'bestof') {
      stepName = 'table'
    }
    delete newTournament[`${stepName}_${nextStep}`]

    setTournament(newTournament)
    setConfig({
      duration: newTournament[`table_duration_${props.step}`],
      name: newTournament[`table_name_${props.step}`],
      promotion: newTournament[`table_promotion_${props.step}`],
      promotion_exact: newTournament[`table_promotion_exact_${props.step}`],
      score: newTournament[`table_score_${props.step}`]
    })

    props.onStart()

    if (newTournament[`table_${props.step}`]) {
      setRounds(newTournament[`table_${props.step}`])
      setSeeding(newTournament[`table_${props.step}_seeding`])
      if (isComplete(newTournament[`table_${props.step}`], newTournament[`table_promotion_exact_${props.step}`])) props.onFinish()
    } else {
      const promoted = (newTournament.participants.filter(p => p.promoted)).map((item, index) => {
        return Object.assign({}, item, { currentSeed: index + 1 })
      })

      // TODO: only calculate rounds that will be fenced, if promotion

      const numberRounds = calcNumberRounds(promoted.length)

      const roundList = []
      for (let i = numberRounds; i >= 1; i -= 1) {
        const tableOf = 2 ** i

        let roundTitle = `Round of ${tableOf}`
        if (tableOf === 2) {
          roundTitle = 'Finals'
        } else if (tableOf === 4) {
          roundTitle = 'Semi-finals'
        }

        const round = {
          id: tableOf,
          title: roundTitle
        }

        const roundMatchups = generateMatches(tableOf)

        const seededRounds = roundMatchups.map((matchup, index) => {
          const p1 = matchup[0]
          const p2 = matchup[1]

          const f1 = _.find(promoted, { placeIndex: p1 - 1 })
          const f2 = _.find(promoted, { placeIndex: p2 - 1 })

          if (i === numberRounds) {
            const s1 = f1
              ? {
                  id: f1.uuid,
                  name: `${f1.last_name}, ${f1.first_name}`,
                  last_name: f1.last_name,
                  first_name: f1.first_name,
                  score: !f2 ? 'BYE' : 0,
                  advanced: !f2 ? undefined : new Array(newTournament[`table_score_${props.step}`]).fill(null)
                }
              : { name: '' }
            const s2 = f2
              ? {
                  id: f2.uuid,
                  name: `${f2.last_name}, ${f2.first_name}`,
                  last_name: f2.last_name,
                  first_name: f2.first_name,
                  score: !f1 ? 'BYE' : 0,
                  advanced: !f1 ? undefined : new Array(newTournament[`table_score_${props.step}`]).fill(null)
                }
              : { name: '' }
            return {
              id: `${tableOf}_${index}`,
              teams: [s1, s2]
            }
          }

          if (i === numberRounds - 1) {
            // handles byes in the first round
            // get previous roun and look for byes

            const lastRound = _.last(roundList)
            const lastMatch = lastRound.seeds.filter(m => m?.teams?.[0]?.id === f1.uuid || m?.teams?.[0]?.id === f2.uuid || m?.teams?.[1]?.id === f1.uuid || m?.teams?.[1]?.id === f2.uuid)

            if (lastMatch) {
              const sf1 = lastMatch.find(m => (m.teams[0].id === f1.uuid && m.teams[1].name === '') || (m.teams[1].id === f1.uuid && m.teams[0].name === ''))
              const sf2 = lastMatch.find(m => (m.teams[0].id === f2.uuid && m.teams[1].name === '') || (m.teams[1].id === f2.uuid && m.teams[0].name === ''))

              const s1 = sf1
                ? {
                    id: f1.uuid,
                    name: `${f1.last_name}, ${f1.first_name}`,
                    last_name: f1.last_name,
                    first_name: f1.first_name,
                    score: !f2 ? 'BYE' : 0,
                    advanced: !f2 ? undefined : new Array(newTournament[`table_score_${props.step}`]).fill(null)
                  }
                : undefined
              const s2 = sf2
                ? {
                    id: f2.uuid,
                    name: `${f2.last_name}, ${f2.first_name}`,
                    last_name: f2.last_name,
                    first_name: f2.first_name,
                    score: !f1 ? 'BYE' : 0,
                    advanced: !f1 ? undefined : new Array(newTournament[`table_score_${props.step}`]).fill(null)
                  }
                : undefined

              // const s1 = sf1 ? { id: f1.uuid, name: `${f1.last_name} ${f1.first_name}` } : undefined
              // const s2 = sf2 ? { id: f2.uuid, name: `${f2.last_name} ${f2.first_name}` } : undefined
              return {
                id: `${tableOf}_${index}`,
                teams: [s1, s2]
              }
            }
          }

          return {
            id: `${tableOf}_${index}`,
            teams: [
              undefined,
              undefined
            ]
          }
        })

        round.seeds = seededRounds
        roundList.push(round)
      }

      if (props.step + 1 === newTournament.schedule.length - 1 &&
        newTournament[`table_fenceoff_${props.step}`]) {
        // add fence off for third
        roundList.push({
          id: 3,
          title: 'Fence off for 3rd',
          seeds: [
            {
              id: '3_0',
              teams: [
                undefined,
                undefined
              ]
            }
          ]
        })
      }

      setRounds(roundList)
      setSeeding(promoted)
      if (isComplete(roundList, newTournament[`table_promotion_exact_${props.step}`])) props.onFinish()
    }

    setIsLoaded(true)
    // eslint-disable-next-line
  }, [props.tournament])

  const saveTournamentData = (newSeeding, scores, complete) => {
    const tournamentData = Object.assign({}, tournament)

    const overallParticipants = []

    for (const participant of tournamentData.participants) {
      let overallParticipant = overallParticipants.find(p => p.uuid === participant.uuid)

      if (complete) {
        if (participant.currentSeed <= config.promotion_exact || config.promotion === 'all') {
          participant.promoted = true
        } else {
          participant.promoted = false
        }
        participant.placeIndex = participant.currentSeed - 1
      }

      if (!overallParticipant) {
        overallParticipants.push(participant)
      } else {
        overallParticipant = participant
      }
    }

    for (const participant of newSeeding) {
      const overallParticipant = overallParticipants.findIndex(p => p.uuid === participant.uuid)

      if (complete) {
        if (participant.currentSeed <= config.promotion_exact || config.promotion === 'all') {
          participant.promoted = true
        } else {
          participant.promoted = false
        }
        participant.placeIndex = participant.currentSeed - 1
      }

      if (overallParticipant < 0) {
        overallParticipants.push(participant)
      } else {
        overallParticipants[overallParticipant] = participant
      }
    }

    tournamentData.participants = overallParticipants
    tournamentData[`table_${props.step}`] = scores
    tournamentData[`table_${props.step}_seeding`] = newSeeding

    props.onTournamentUpdate(tournamentData)
    if (complete) {
      props.onFinish()
    }
  }

  const isComplete = (rnds, promotion) => {
    const validRounds = rnds.filter(r => r?.id > promotion || _.isUndefined(promotion))

    const done = validRounds.every(t => {
      const rndCompleted = t.seeds.every(seed => {
        const matchCompleted =
          seed?.teams?.[0]?.isWinner ||
          seed?.teams?.[1]?.isWinner ||
          _.toLower((seed?.teams?.[0]?.score)) === 'bye' ||
          _.toLower((seed?.teams?.[1]?.score)) === 'bye'
        return matchCompleted
      })
      return rndCompleted
    })

    return done
  }

  const handleScoring = (seed) => {
    setCurrentMatch(seed)
    setIsSetScoreVisible(true)
  }

  const handleScoreEdit = (seed) => {
    setCurrentMatch(seed)
    setIsSetScoreVisible(true)
  }

  const handleCancel = () => {
    setIsSetScoreVisible(false)
  }

  const CustomSeed = ({ seed, breakpoint, roundIndex, seedIndex }) => {
    console.log(config)

    const roundOf = _.toNumber(_.first(seed?.id?.split('_'))) || 0
    const shouldDisplay = roundOf > config.promotion_exact || config.promotion === 'all'

    const canClick = seed?.teams?.[0]?.id &&
      seed?.teams?.[1]?.id &&
      !seed?.teams?.[0]?.isWinner &&
      !seed?.teams?.[1]?.isWinner &&
      (roundOf > config.promotion_exact || config.promotion === 'all')

    const isComplete = seed?.teams?.[0]?.isWinner ||
      seed?.teams?.[1]?.isWinner ||
      _.toLower((seed?.teams?.[0]?.score)) === 'bye' ||
      _.toLower((seed?.teams?.[1]?.score)) === 'bye' ||
      roundOf <= config.promotion_exact

    if (shouldDisplay) {
      return (
        <Seed mobileBreakpoint={breakpoint} style={{ fontSize: 12 }}>
          <SeedItem className={`${isComplete ? 'seed-complete' : 'seed-item'} ${canClick ? 'seed-clickable' : ''}`}>
            <div onClick={() => { if (canClick) { handleScoring(seed) } }}>
              {isComplete && (seed?.teams?.[0]?.isWinner || seed?.teams?.[1]?.isWinner) ? <EditOutlined className='seed-edit' onClick={() => { handleScoreEdit(seed) }} /> : ''}
              <SeedTeam className={seed?.teams?.[0]?.isWinner ? 'seed-winner' : ''}>{seed?.teams?.[0]?.isWinner ? <StarFilled style={{ color: '#ebc334' }} /> : ''}{seed?.teams?.[0]?.name || '\u00a0'} {!_.isUndefined(seed?.teams?.[0]?.score) || seed?.teams?.[0]?.score === 'BYE' ? `(${seed?.teams?.[0]?.isWinner && _.first(seed?.teams?.[0]?.score) !== 'V' ? 'V' : ''}${seed?.teams?.[0]?.score})` : '\u00a0'}</SeedTeam>
              <SeedTeam className={seed?.teams?.[1]?.isWinner ? 'seed-winner' : ''}>{seed?.teams?.[1]?.isWinner ? <StarFilled style={{ color: '#ebc334' }} /> : ''}{seed?.teams?.[1]?.name || '\u00a0'} {!_.isUndefined(seed?.teams?.[1]?.score) || seed?.teams?.[1]?.score === 'BYE' ? `(${seed?.teams?.[1]?.isWinner && _.first(seed?.teams?.[1]?.score) !== 'V' ? 'V' : ''}${seed?.teams?.[1]?.score})` : '\u00a0'}</SeedTeam>
              <div className={`${!canClick ? 'match-no-display' : 'match-display'}`}>{seed?.id}</div>
            </div>
          </SeedItem>
        </Seed>
      )
    }
    return (<></>)
  }

  const CustomTitle = (title, roundIndex) => {
    if (rounds[roundIndex]?.id > config.promotion_exact || !config.promotion_exact) {
      return <div className='round-title'>{title}</div>
    }

    return <></>
  }

  const handlePrintDialog = () => {
    setPrintValue('a')
    setIsPrintVisible(true)
  }

  const handlePrint = () => {
    handlePrintTable()
    setIsPrintVisible(false)
  }

  const handlePrintConfig = (e) => {
    setPrintValue(e.target.value)
  }

  const handleCloseModal = () => {
    setIsPrintVisible(false)
  }

  const handleMatchScoreDone = () => {
    const seed = currentMatch
    const tableOf = (_.split(seed.id, '_'))[0]
    const index = rounds.findIndex(f => f.id === parseInt(tableOf, 10))
    const seedIndex = rounds[index].seeds.findIndex(s => s.id === seed.id)

    const match = rounds[index].seeds[seedIndex]

    const newRounds = JSON.parse(JSON.stringify(rounds))

    newRounds[index].seeds[seedIndex] = match
    setCurrentMatch(rounds[index].seeds[seedIndex])
    setRounds(newRounds)

    setIsSetScoreVisible(false)
  }

  const handleMatchScore = (match) => {
    const maxScore = parseInt(config.score, 10)
    const seed = currentMatch
    const newScores = JSON.parse(JSON.stringify(rounds))
    const newSeeding = JSON.parse(JSON.stringify(seeding))

    const tableOf = (_.split(seed.id, '_'))[0]
    const index = newScores.findIndex(f => f.id === parseInt(tableOf, 10))
    const seedIndex = newScores[index].seeds.findIndex(s => s.id === seed.id)

    newScores[index].seeds[seedIndex].teams = match.teams

    const p1 = newSeeding.find(f => f.uuid === newScores[index].seeds[seedIndex].teams[0].id)
    const p2 = newSeeding.find(f => f.uuid === newScores[index].seeds[seedIndex].teams[1].id)

    if (_.toInteger(match.teams[0].score) === maxScore || _.toLower(match.teams[0].score) === 'v') {
      newScores[index].seeds[seedIndex].teams[0].score = 'V'
      newScores[index].seeds[seedIndex].teams[0].isWinner = true
      newScores[index].seeds[seedIndex].teams[1].isWinner = false
      if (p2.currentSeed < p1.currentSeed) {
        p1.currentSeed = p2.currentSeed
      }
      p2.currentSeed = _.toInteger(tableOf) / 2 + 1
      if (tableOf === 3) {
        p2.currentSeed = 4
      }
    } else if (_.toInteger(match.teams[0].score) > maxScore || _.toLower(_.first(match.teams[0].score)) === 'v') {
      if (_.toLower(_.first(match.teams[0].score)) === 'v') {
        newScores[index].seeds[seedIndex].teams[0].score = match.teams[0].score
      } else {
        newScores[index].seeds[seedIndex].teams[0].score = `V${_.toInteger(match.teams[0].score)}`
      }
      newScores[index].seeds[seedIndex].teams[0].isWinner = true
      newScores[index].seeds[seedIndex].teams[1].isWinner = false
      if (p2.currentSeed < p1.currentSeed) {
        p1.currentSeed = p2.currentSeed
      }
      p2.currentSeed = _.toInteger(tableOf) / 2 + 1
      if (tableOf === 3) {
        p2.currentSeed = 4
      }
    } else if (_.toInteger(parseInt(match.teams[1].score) === maxScore || _.toLower(match.teams[1].score) === 'v')) {
      newScores[index].seeds[seedIndex].teams[1].score = 'V'
      newScores[index].seeds[seedIndex].teams[1].isWinner = true
      newScores[index].seeds[seedIndex].teams[0].isWinner = false
      if (p2.currentSeed > p1.currentSeed) {
        p2.currentSeed = p1.currentSeed
      }
      p1.currentSeed = _.toInteger(tableOf) / 2 + 1
      if (tableOf === 3) {
        p1.currentSeed = 4
      }
    } else if (_.toInteger(match.teams[1].score) > maxScore || _.toLower(_.first(match.teams[1].score)) === 'v') {
      if (_.toLower(_.first(match.teams[1].score)) === 'v') {
        newScores[index].seeds[seedIndex].teams[1].score = match.teams[1].score
      } else {
        newScores[index].seeds[seedIndex].teams[1].score = `V${_.toInteger(match.teams[1].score)}`
      }
      newScores[index].seeds[seedIndex].teams[1].isWinner = true
      newScores[index].seeds[seedIndex].teams[0].isWinner = false
      if (p2.currentSeed > p1.currentSeed) {
        p2.currentSeed = p1.currentSeed
      }
      p1.currentSeed = _.toInteger(tableOf) / 2 + 1
      if (tableOf === 3) {
        p1.currentSeed = 4
      }
    } else if (_.toInteger(match.teams[0].score) > _.toInteger(match.teams[1].score)) {
      newScores[index].seeds[seedIndex].teams[0].isWinner = true
      newScores[index].seeds[seedIndex].teams[1].isWinner = false
      if (p2.currentSeed < p1.currentSeed) {
        p1.currentSeed = p2.currentSeed
      }
      p2.currentSeed = _.toInteger(tableOf) / 2 + 1
      if (tableOf === 3) {
        p2.currentSeed = 4
      }
    } else if (_.toInteger(match.teams[1].score) > _.toInteger(match.teams[0].score)) {
      newScores[index].seeds[seedIndex].teams[1].isWinner = true
      newScores[index].seeds[seedIndex].teams[0].isWinner = false
      if (p2.currentSeed > p1.currentSeed) {
        p2.currentSeed = p1.currentSeed
      }
      p1.currentSeed = _.toInteger(tableOf) / 2 + 1
      if (tableOf === 3) {
        p1.currentSeed = 4
      }
    }

    // recalculate next round
    const recalcedScores = newScores.map((item, tableIndex) => {
      if (item.id === 3) {
        if (newScores[index].id !== item.id) {
          const semiFinals = newScores.find(s => s.id === 4)

          const losers = semiFinals.seeds.map(sf => {
            if (sf?.teams?.[0]?.isWinner) {
              return _.pick(sf?.teams?.[1], ['id', 'name'])
            } else if (!_.isUndefined(sf?.teams?.[1]?.score)) {
              return _.pick(sf?.teams?.[0], ['id', 'name'])
            } else {
              return undefined
            }
          })

          const seededRound = {
            id: '3_0',
            teams: losers
          }

          return Object.assign({}, item, { seeds: [seededRound] })
        }
      }
      if (item.id < parseInt(tableOf, 10) && newScores?.[tableIndex - 1]?.id === parseInt(tableOf, 10)) {
        const roundMatchups = generateMatches(item.id)
        const seededRounds = roundMatchups.map((matchup, matchIndex) => {
          const existingMatch = item.seeds.find(t => t?.id === `${item.id}_${matchIndex}`)
          const winner = newScores[index].seeds[seedIndex].teams[0].isWinner ? newScores[index].seeds[seedIndex].teams[0] : newScores[index].seeds[seedIndex].teams[1]
          const winnerInfo = newSeeding.find(f => f.uuid === winner.id)

          if (winnerInfo.currentSeed === matchup[0] || winnerInfo.currentSeed === matchup[1]) {
            const teamIndex = matchup[0] === winnerInfo.currentSeed ? 0 : 1

            if (existingMatch?.teams?.[teamIndex]) {
              existingMatch.teams[teamIndex] = {
                id: winner.id,
                name: winner.name,
                score: undefined
              }
            } else if (existingMatch?.teams) {
              if (teamIndex === 0) {
                existingMatch.teams = [
                  {
                    id: winner.id,
                    name: winner.name,
                    score: undefined
                  },
                  existingMatch?.teams[1] ? existingMatch.teams[1] : undefined
                ]
              } else {
                existingMatch.teams = [
                  existingMatch?.teams[0] ? existingMatch.teams[0] : undefined,
                  {
                    id: winner.id,
                    name: winner.name,
                    score: undefined
                  }
                ]
              }
            } else {
              return {
                id: `${item.id}_${matchIndex}`,
                teams: [
                  teamIndex === 0 ? { id: winner.id, name: winner.name, score: undefined } : undefined,
                  teamIndex === 1 ? { id: winner.id, name: winner.name, score: undefined } : undefined
                ]
              }
            }
          }

          return existingMatch
        })
        return Object.assign({}, item, { seeds: seededRounds })
      }

      return item
    })

    setRounds(recalcedScores)
    setSeeding(newSeeding)

    const promotion = parseInt(config.promotion, 10)

    saveTournamentData(newSeeding, recalcedScores, isComplete(recalcedScores, config.promotion_exact))

    if (parseInt(tableOf, 10) <= promotion) {
      // future functionality, allow export to new round
      saveTournamentData(newSeeding, recalcedScores, true)
    }
  }

  return (
    <div className='tournament-table-scoring-parent'>
      <div className='tournament-menu tournament-table-scoring'>
        <Row gutter={[8]}>
          <Col flex='none'>
            <Button block className='menu-btn' shape='round' onClick={handlePrintDialog} type='info'>
              <PrinterOutlined />
              Print
            </Button>
          </Col>
        </Row>
      </div>
      <Bracket rounds={rounds} renderSeedComponent={CustomSeed} roundTitleComponent={CustomTitle} />
      <Modal
        visible={isSetScoreVisible}
        title={`${currentMatch?.teams?.[0]?.name} vs ${currentMatch?.teams?.[1]?.name}`}
        // eslint-disable-next-line
        onOk={handleMatchScoreDone}
        onCancel={handleCancel}
        maskClosable={false}
        destroyOnClose
        width={1024}
      >
        <TableScoreCard config={config} key={currentMatch.id} round={currentMatch} onMatchScore={handleMatchScore} />
      </Modal>
      <Modal
        title='Print Which Sheets?' visible={isPrintVisible} onCancel={handleCloseModal} onOk={handlePrint} maskClosable={false} destroyOnClose width={800}
      >
        <Radio.Group value={printValue} size='large' onChange={handlePrintConfig}>
          <Space direction='vertical'>
            <Radio value='a'>Bracket</Radio>
            <Radio value='b'>Ready Match Score Sheets</Radio>
            <Radio value='c'>Ready + Blank Match Score Sheets</Radio>
          </Space>
        </Radio.Group>
      </Modal>
      <div style={{ display: 'none' }}>
        {isLoaded
          ? (
            <PrintTable config={config} ref={printTableRef} sheetLayout={printValue} rounds={rounds} seeding={seeding} />
            )
          : ''}
      </div>
    </div>
  )
}

export default TournamentTableScoring
